export default "__VITE_ASSET__2I4LNcHh__"